<mat-chip-set>
    @for (facet of displayedFacets() | slice:0:(showAllFacets() ?
    displayedFacets().length : 5); track facet) {
    <mat-chip
        [class.lifecycle-phase-chip]="facet[0] === 'lifecycle'"
        [class.persona-chip]="facet[0] === 'persona'"
        [class.tool-type-chip]="facet[0] === 'tooltype'"
        [ngbTooltip]="tooltipLabel(facet[0])"
    >
        {{ facet[1] }}
    </mat-chip>
    } @if (displayedFacets().length > 5) {
    <mat-chip
        class="expand-facets-chip"
        (click)="toggleShowAllFacets()"
        clickable
    >
        {{ showAllFacets() ? "Show less" : "Show more" }}
    </mat-chip>
    }
</mat-chip-set>
